import venuesSliderTable from './modules/venuesSliderTable';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const quoteSlider = $('.section-common-quote .slider');
    if (quoteSlider.length) {
      quoteSlider.slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        prevArrow: $('.section-common-quote .prev'),
        nextArrow: $('.section-common-quote .next'),
        adaptiveHeight: true,
      });
    }

    venuesSliderTable();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelWeddingMeetings.js